import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "global-setting" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
    /*#__PURE__*/_createElementVNode("h4", { class: "mr-3 font-normal" }, "Pengaturan Global")
  ])
], -1)
const _hoisted_3 = { class: "mx-5 mb-3 text-lg font-semibold" }
const _hoisted_4 = { class: "md:grid grid-cols-2 gap-8 mx-5 bottom-separator" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = ["for"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-info-circle" }, null, -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 0,
  class: "p-inputgroup w-full mt-1"
}
const _hoisted_10 = {
  key: 0,
  class: "p-inputgroup-addon"
}
const _hoisted_11 = {
  key: 1,
  class: "p-inputgroup-addon"
}
const _hoisted_12 = {
  key: 2,
  class: "p-inputgroup-addon"
}
const _hoisted_13 = {
  key: 1,
  class: "p-inputgroup w-full mt-1"
}
const _hoisted_14 = { class: "action-button mt-10 mx-5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-sm" }, "Simpan Global Setting", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popper = _resolveComponent("Popper")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _hoisted_2
      ]),
      content: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.dataset, (items) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "mb-10",
            key: items[0]
          }, [
            _createElementVNode("p", _hoisted_3, _toDisplayString(items[2]), 1),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items[1], (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "p-field",
                  key: item.Id
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("label", {
                      for: item.Code,
                      class: "mr-2 required"
                    }, _toDisplayString(item.Name), 9, _hoisted_6),
                    _createVNode(_component_Popper, {
                      arrow: "",
                      hover: "",
                      content: item.Description
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 2
                    }, 1032, ["content"])
                  ]),
                  (item.Type === 'NUM')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (item.Code == 'SL' || item.Code == 'DL' || item.Code == 'BP')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                              _createVNode(_component_InputText, {
                                type: "number",
                                class: "input-primary rounded-lg w-full",
                                id: item.Code,
                                modelValue: item.Value,
                                "onUpdate:modelValue": ($event: any) => ((item.Value) = $event),
                                placeholder: item.Description
                              }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "placeholder"]),
                              (item.Code == 'SL')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString('Detik')))
                                : _createCommentVNode("", true),
                              (item.Code == 'BP')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString('Menit')))
                                : _createCommentVNode("", true),
                              (item.Code == 'DL')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString('Hari')))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              _createVNode(_component_InputText, {
                                type: "number",
                                class: "input-primary rounded-lg w-full",
                                id: item.Code,
                                modelValue: item.Value,
                                "onUpdate:modelValue": ($event: any) => ((item.Value) = $event),
                                placeholder: item.Description
                              }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "placeholder"])
                            ]))
                      ]))
                    : (item.Type == 'STRA')
                      ? (_openBlock(), _createBlock(_component_Textarea, {
                          key: 1,
                          placeholder: item.Description,
                          class: "input-primary w-full rounded-lg mt-1",
                          modelValue: item.Value,
                          "onUpdate:modelValue": ($event: any) => ((item.Value) = $event)
                        }, null, 8, ["placeholder", "modelValue", "onUpdate:modelValue"]))
                      : (item.Code == 'NA')
                        ? (_openBlock(), _createBlock(_component_InputText, {
                            key: 2,
                            type: "tel",
                            modelValue: item.Value,
                            "onUpdate:modelValue": ($event: any) => ((item.Value) = $event),
                            class: "input-primary w-full rounded-lg mt-1",
                            pattern: "/^0?[1-9][0-9]{6,14}$/"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                        : (_openBlock(), _createBlock(_component_InputText, {
                            key: 3,
                            id: item.Code,
                            placeholder: item.Description,
                            modelValue: item.Value,
                            "onUpdate:modelValue": ($event: any) => ((item.Value) = $event),
                            class: "w-full mt-1 input-primary rounded-lg"
                          }, null, 8, ["id", "placeholder", "modelValue", "onUpdate:modelValue"]))
                ]))
              }), 128))
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_Button, {
            class: "px-10 mr-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.submitData()))
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}